document.body.addEventListener("mousedown", () => {
    document.body.classList.remove("using-keyboard");
});

// Re-enable focus styling when Tab is pressed
document.body.addEventListener("keydown", (e) => {
    if (e.key === "Tab") document.body.classList.add("using-keyboard");
});